import React from 'react';
import { Section, Container } from '../common';
import { UserPlus, Settings2, Rocket, ArrowRight } from 'lucide-react';

const steps = [
  {
    icon: <UserPlus size={28} />,
    title: 'Crie sua conta',
    description: 'Cadastre seu restaurante em poucos minutos e tenha acesso imediato ao painel de controle.'
  },
  {
    icon: <Settings2 size={28} />,
    title: 'Monte seu cardápio',
    description: 'Adicione seus produtos com fotos, descrições e preços de forma intuitiva e profissional.'
  },
  {
    icon: <Rocket size={28} />,
    title: 'Comece a vender',
    description: 'Compartilhe seu link exclusivo, ative seu robô e veja os pedidos chegarem sozinhos.'
  }
];

const Steps = () => {
  return (
    <Section id="como-funciona" className="bg-white">
      <Container>
        <div className="text-center mb-5 max-width-700 mx-auto" data-aos="fade-up">
          <span className="badge bg-primary-custom text-black mb-3 px-3 py-2 rounded-pill fw-bold">
            PASSO A PASSO
          </span>
          <h2 className="fw-bold display-5 mb-3">Começar é muito simples</h2>
          <p className="text-secondary lead">
            Em menos de 10 minutos você coloca seu restaurante no mundo digital e começa a vender mais.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {steps.map((step, index) => (
            <div key={index} className="col-md-4 step-item" data-aos="fade-up" data-aos-delay={index * 150}>
              <div className="text-center step-line d-flex flex-column align-items-center">
                <div className="step-number">
                  {index + 1}
                </div>
                <div className="px-3">
                  <h3 className="h5 fw-bold mb-3">{step.title}</h3>
                  <p className="text-secondary small mb-0 lh-lg">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 pt-4">
          <div className="bg-light p-4 rounded-4 d-inline-block border">
            <p className="fw-bold mb-3">Pronto para modernizar seu atendimento?</p>
            <a href="/cadastro" className="btn btn-primary-custom btn-lg px-5 shadow-sm">
              Criar meu cardápio <ArrowRight className="ms-2" size={20} />
            </a>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Steps;
